import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { Chip } from "@mui/material";
import { SubscriptionStatusType } from "@/types/graphql/partner.generated";

interface RenewStatusProps {
  // Подписка покупки: у разовых покупок её нет, тогда колонка пустая
  // (референс RenewStatus.js:10-12 выходит по `!recurrent`).
  subscription?: {
    renewSubscription: boolean;
    status: SubscriptionStatusType;
  } | null;
}

/**
 * Состояние автопродления в списке покупок (референс
 * partner/components/Rightholder/ProductPurchases/ProductPurchasesList/
 * RenewStatus.js:7-60). Неудачное продление показывается статусом
 * подписки «Просрочена» (спека viewer-money); причина и попытки в
 * карточке подписки.
 */
export const RenewStatus: FC<RenewStatusProps> = ({ subscription }) => {
  const { t } = useTranslation();

  if (!subscription) return null;

  if (subscription.status === SubscriptionStatusType.PastDueType) {
    return (
      <Chip size="small" color="error" label={t("purchases.renew.pastDue")} />
    );
  }

  return subscription.renewSubscription ? (
    <Chip size="small" color="success" label={t("purchases.renew.enabled")} />
  ) : (
    <Chip size="small" color="warning" label={t("purchases.renew.disabled")} />
  );
};
